import API from '@/api'

export default {
  namespaced: true,
  state: {
    users: [],
    activeUser: false
  },
  mutations: {
    parseUsers(state, data) {
      state.users = [];
      state.activeUser = false;

      for (var item of data) {
        item.fields = [];
        item.programs = [];
        item.crops = [];

        for (var farm of item.farms) {
          for (var field of farm.fields) {
            var res_field = {};
            res_field.id = field.id;
            res_field.farm_name = farm.name;
            res_field.farmId = field.farmId;
            res_field.name = field.name;
            res_field.area = field.area;
            res_field.type = field.type;
            res_field.shape = field.shape;
            res_field.cropId = field.cropId;
            item.fields.push(res_field);

            if (field.programs != null) {
              for (var program of field.programs) {
                var res_program = {};
                res_program.id = program.id;
                res_program.name = program.name;
                res_program.fieldId = program.fieldId;
                res_program.farmId = program.farmId;
                res_program.type = program.type;
                res_program.name = program.name;
                res_program.endDate = program.plantingDate;
                res_program.current = program.currentStep;
                res_program.cropName = program.crop.name;
                item.programs.push(res_program);
  
                var res_crop = {};
                res_crop.id = program.crop.id;
                res_crop.name = program.crop.name;
                res_crop.type = program.crop.type;
                res_crop.owner = program.crop.owner == 0 ? 'System' : 'User defined';
                item.crops.push(res_crop);
              }
            }
          }
        }

        state.users.push(item);
      }
    },
    setUser (state, userId) {
      state.activeUser = userId;
    }
  },
  actions: {
    loadCompanyDashboard({ commit }) {
      return API.user.getCompanyDashboard().then(res => {
        commit('parseUsers', res.data.data);

        return res.data.data;
      });
    }
  },
  getters: {
    company (state) {
      return state.users;
    },
    activeUser (state) {
      for (var user of state.users) {
        if (user.id == state.activeUser) {
          return {
            firstName: user.firstName,
            lastName: user.lastName,
            country: user.country,
            city: user.city,
            id: user.id,
          }
        }
      }
      return false;
    },
    activeUserId (state) {
      return state.activeUser;
    },
    users (state) {
      return state.users.map(item => {
        return {
          firstName: item.firstName,
          lastName: item.lastName,
          country: item.country,
          city: item.city,
          id: item.id,
        }
      });
    },
    fields (state) {
      for (var user of state.users) {
        if (user.id == state.activeUser) {
          return user.fields.map(item => {
            return {
              name: item.name,
              farm_name: item.farm_name,
              area: item.area,
              id: item.id
            }
          });
        }
      }
      return false;
    },
    programs (state) {
      for (var user of state.users) {
        if (user.id == state.activeUser) {
          return user.programs.map(item => {
            return {
              name: item.name,
              endDate: item.endDate,
              cropName: item.cropName,
              current: item.current,
              id: item.id
            }
          });
        }
      }
      return false;
    },
    crops (state) {
      for (var user of state.users) {
        if (user.id == state.activeUser) {
          return user.crops.map(item => {
            return {
              name: item.name,
              type: item.type,
              owner: item.owner,
              id: item.id
            }
          });
        }
      }
      return false;
    },
  }
};;
